import { SET_CROP_BOUNDS, SET_ZOOM } from '../actions/map';

const defaultState = {
  cropBounds: null,
  zoom: null,
};

const mapReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_CROP_BOUNDS:
      return {
        ...state,
        cropBounds: action.payload,
      };
    case SET_ZOOM:
      return {
        ...state,
        zoom: action.payload,
      };
    default:
      return state;
  }
};

export default mapReducer;
